exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".paged-table .ant-alert-info{border:1px solid #91d5ff;padding:8px 15px 8px 15px;border-radius:4px;font-size:14px;color:rgba(0,0,0,.65);background-color:#e6f7ff;margin-bottom:10px}.paged-table-btns{margin-bottom:20px}.paged-table-img{width:60px;height:60px}.paged-table-pager{margin-top:20px;text-align:center}.paged-table-btn{display:-webkit-box;display:-ms-flexbox;display:flex}.paged-table-btn .el-button{margin-right:10px}.paged-table .sku{display:inline-block;padding:3px 5px;background:#eee;border-radius:4px;font-size:12px;margin-right:5px}", ""]);

// exports
